export default __webpack_public_path__ + "static/starcoin-illustration-light-e9efc883efa13ad4287e44e42fae8d4e.svg";